<div class="snack-bar-content">
  <div class="snack-bar-text" [innerHTML]="data.message"></div>
</div>
